// Page-wide constants for ProductDetailPageV2 and its subcomponents

// General Defaults
export const DEFAULT_CURATOR_NAME = 'Mavu';
export const TOAST_DURATION = 2500; // ms

// Countdown Timer constants
export const COUNTDOWN_HOURS = 5;
export const COUNTDOWN_INTERVAL = 1000; // ms

// Pricing & Offers
export const SPECIAL_OFFER_MULTIPLIER = 0.85;

// Ratings and Reviews Fallbacks
export const DEFAULT_RATING = 4.7;
export const DEFAULT_RATING_COUNT = 143;
export const DEFAULT_REVIEWS_DISTRIBUTION = {
  5: 100,
  4: 30,
  3: 10,
  2: 2,
  1: 1,
};
export const DEFAULT_AI_REVIEW_SUMMARY =
  'Customer says the product is very comfortable and high quality but not fit to size and slightly and slightly customer says the product is very comfortable and high quality but not fit to size and slightly and slightly';

export const MOCK_REVIEW_PHOTOS = [
  'https://images.meesho.com/images/products/318283592/gsk10_512.webp',
  'https://images.meesho.com/images/products/318283592/t9gsk_512.webp',
];

export const MOCK_REVIEWS_LIST = [
  {
    username: 'K Chandana',
    rating: '4',
    text: "Dress is too good but I ordered L size and it's too small M size it is but dress is awesome 👍",
    images: MOCK_REVIEW_PHOTOS,
  },
  {
    username: 'K Chandana',
    rating: '4',
    text: "Dress is too good but I ordered L size and it's too small M size it is but dress is awesome 👍",
    images: MOCK_REVIEW_PHOTOS,
  },
];

// Policies Defaults
export const DEFAULT_RETURN_POLICY =
  'We offer a hassle-free 7-day return policy. If you are not satisfied with the product, you can initiate a return or exchange request within 7 days of delivery. The product must be unused and in its original packaging.';
export const DEFAULT_SHIPPING_POLICY =
  'Orders are shipped within 24-48 hours and typically delivered within 3-5 business days. Cash on delivery is available for all pin codes.';
export const DEFAULT_PRIVACY_POLICY =
  'We secure your personal data and do not share it with third parties. Your payment information is encrypted and processed securely.';
